import React from 'react';
import { useIntl } from 'react-intl';

const AdminTaxonomiesListHeader = () => {
  const intl = useIntl();

  return (
    <tr>
      <th>{' '}</th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Name' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Plural name' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Tags' })}
      </th>
      <th className="th-min-content">
        {intl.formatMessage({ defaultMessage: 'Visible on shares' })}
      </th>
      <th>
        {intl.formatMessage({ defaultMessage: 'Required' })}
      </th>
      <th>
        {' '}
      </th>
    </tr>
  );
};

export default AdminTaxonomiesListHeader;
